<template>
    <div class="well well-sm">
        <div class="row">
            <div class="col-sm-6 col-md-4">
                <v-gravatar :email="user.email" default-img="mp" :size="380" v-if="user.email"></v-gravatar>
                <img src="../../assets/images/default_user_icon.png" size="380" v-if="!user.email">
            </div>
            <div class="col-sm-6 col-md-8 pt-2 pb-2">
                <h4>
                    {{user.first_name}} {{user.last_name}}
                </h4>
                <div v-if="user.title">{{user.title}}</div>
                <div v-if="user.email">
                    <font-awesome-icon icon="envelope"></font-awesome-icon>
                    {{user.email}}
                    <br/>
                </div>
                <div v-if="user.phone">
                    <font-awesome-icon icon="phone"></font-awesome-icon>
                    {{user.phone | phone}}
                    <br/>
                </div>
                <div v-if="user.fax">
                    <font-awesome-icon icon="fax"></font-awesome-icon>
                    {{user.fax | phone}}
                </div>
            </div>
        </div>
        <div class="row mt-2 pb-2 pr-2 float-right">
            <div class="col-sm-12">
                <div v-if="type === 'group_admin'">
                    <b-dropdown text="Options">
                        <b-dropdown-item to="/dashboard/group-admin/update">Change Profile</b-dropdown-item>
                        <b-dropdown-item to="/dashboard/group-admin/preferences">Change Preferences</b-dropdown-item>
                    </b-dropdown>
                </div>
                <div v-if="type === 'producer'">
                    <b-dropdown text="Options">
                        <b-dropdown-item to="/dashboard/producer/update">Change Profile</b-dropdown-item>
                        <b-dropdown-item to="/dashboard/producer/password">Change Password</b-dropdown-item>
                        <b-dropdown-item to="/dashboard/producer/preferences">Change Preferences</b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</template>

<script>
    export default {
        name: 'ContactCard',
        props: ['user', 'business', 'type']
    }
</script>


<style scoped>
    .well {
        background: #F9F9F9
    }

    .glyphicon {
        margin-bottom: 10px;
        margin-right: 10px;
    }

    small {
        display: block;
        line-height: 1.428571429;
        color: #999;
    }
</style>
